<template>
    <div class="tab-content-wrap h-75">

        <edit-switch :tab="selectedTab" :edit="editEnabled" :initialCondition="selectedTab == 2" v-on:toggleEdit="handleToggle" />
        <div class="tab-content h-100">
            <div class="item-content h-100">
                <div class="access-sg text clearfix">
                    <div class="d-flex justify-content-between" style="border-bottom: 1px solid #282D69;">
                        <div class="title">
                            Students
                        </div>
                        <button type="button" v-if="editEnabled" class="btn btn-add-alt text-white" v-on:click="$emit('eval')">RE-EVALUATE</button>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="table-responsive">
                                <table class="table bd-dark-blue" style="border-radius: 0 0 10px 10px;">
                                    <thead>
                                        <tr>
                                            <th>
                                                User Name
                                            </th>
                                            <th>
                                                Progress
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="allocations.length < 1">
                                            <td colspan="2" class="text-center">No students yet</td>
                                        </tr>
                                        <tr v-for="allocation in allocations">
                                            <td>
                                                {{ allocation.user.firstName }} {{ allocation.user.lastName}}<br />
                                                                                                             <small>{{allocation.user.email}}</small>
                                            </td>
                                            <td>
                                                Completed: {{ allocation.completed !== null ? allocation.completed : "False" }}<br />
                                                Score: {{ allocation.score !== null ? allocation.score : '0' }}<br />
                                                Passed: {{ allocation.passed !== null ? allocation.passed : "False" }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "StudentsPage",
        props: ["edit", "tab", "initialAllocations"],
        data() {
            return {
                editEnabled: this.edit,
                selectedTab: this.tab,
                allocations: this.initialAllocations == null ? [] : this.initialAllocations
            }
        },
        watch: {
            edit: function (newVal, oldVal) {
                this.editEnabled = newVal;
            },
            tab: function (newVal, oldVal) {
                this.selectedTab = newVal;
            },
            initialAllocations: function (newVal, oldVal) {
                this.allocations = newVal == null ? [] : newVal;
            },
        },
        methods:{
            handleToggle(){
                this.$emit('toggleEdit');
            }
        },
        mounted() {
            //console.log("Students page loaded");
        },
    }
</script>